import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { trackOrder } from '../../services/api';
import {FaCheck} from 'react-icons/fa6';
export default function TrackOrder() {
  const [searchParams] = useSearchParams();
  const [phone, setPhone] = useState(searchParams.get('phone') || '');
  const [orderId, setOrderId] = useState(searchParams.get('order_id') || '');
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const isSuccess = searchParams.get('success') === 'true';

  const handleTrack = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await trackOrder(phone, orderId);
      setOrder(data);
    } catch (err) {
      setError(err.message);
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black py-12 px-4" dir="rtl">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-black text-white mb-8">تتبع الطلب</h1>

        {/* Success message */}
        {isSuccess && (
          <div className="bg-green-900/50 text-green-300 p-6 rounded-2xl mb-8 text-center border border-green-700">
            <FaCheck className="text-green-500 text-4xl mb-4 mx-auto" />
            <h2 className="text-2xl font-black mb-2">تم تقديم الطلب بنجاح!</h2>
            <p className="text-green-200">
              رقم طلبك هو: <strong className="text-white text-xl">#{orderId}</strong>
            </p>
            <p className="text-green-300 mt-2">
              سنقوم بالتواصل معك قريباً لتأكيد الطلب.
            </p>
          </div>
        )}

        <form onSubmit={handleTrack} className="bg-neutral-950 p-8 rounded-2xl shadow-xl border border-neutral-800 space-y-4">
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">رقم الهاتف</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white" />
          </div>
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">رقم الطلب</label>
            <input value={orderId} onChange={(e) => setOrderId(e.target.value)} required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white" />
          </div>
          <button type="submit" disabled={loading}
            className="bg-red-600 text-white w-full py-4 font-bold rounded-xl hover:bg-red-700 disabled:bg-neutral-700 transition">
            {loading ? 'جار البحث...' : 'تتبع'}
          </button>
        </form>

        {error && <div className="bg-red-900/50 text-red-300 p-4 rounded-lg mt-4">{error}</div>}

        {order && (
          <div className="bg-neutral-950 p-8 rounded-2xl shadow-xl border border-neutral-800 mt-8 text-white">
            <h2 className="text-xl font-black mb-4">تفاصيل الطلب #{order.id}</h2>
            <p><strong className="text-neutral-400">الحالة:</strong> <span className="text-red-500 font-bold">{order.status}</span></p>
            <p><strong className="text-neutral-400">الاسم:</strong> {order.customer_name}</p>
            <p><strong className="text-neutral-400">العنوان:</strong> {order.address}, {order.city}</p>
            <p><strong className="text-neutral-400">المجموع:</strong> {order.total} شيكل</p>
            <div className="mt-4">
              <h3 className="font-bold">المنتجات:</h3>
              <ul className="list-disc list-inside">
                {order.items.map((item, idx) => (
                  <li key={idx}>{item.product_name} × {item.quantity}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}